import { setupPlausible } from '../../components/plausible';
window.up.compiler('.js-post_recommended_other_publication', element => {
    var _a, _b;
    if (element instanceof HTMLElement) {
        const { trackEvent } = setupPlausible();
        const sourcePublicationId = ((_a = element.dataset) === null || _a === void 0 ? void 0 : _a.sourcePublicationId) || '';
        const recommendedPublicationId = ((_b = element.dataset) === null || _b === void 0 ? void 0 : _b.recommendedPublicationId) || '';
        trackEvent('Project Recommendation Shown', {
            props: {
                page: 'post',
                recommendation_source_publication_id: sourcePublicationId,
                publication_id: recommendedPublicationId,
                recommended_by: 'steady'
            }
        });
    }
});
